const option = (optionId) => ({
  optionId,
  name: "",
});

export default option;
